import React from 'react';
import { connect } from 'react-redux';
import InternetPackageCard from './InternetPackageCard'

const InternetPackagesHolder = (props) => {
    return (
        <div className="internet-packages">
            <div className="packages-wrapper clearfix" style={props.internetPackages && props.internetPackages.length > 2 ? {textAlign:'right'} : {}}>
                {                          
                props.internetPackages && props.internetPackages.length > 0 ? 
                props.internetPackages.map(function(p, i){  
                    return <InternetPackageCard key={i} cardNumber={i} package={p} onSelected={props.onSelected} />
                })
                : null                
                }    
            </div> 
        </div>
    )
}

const mapStateToProps = (state) => {
    return {}
}
 
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(InternetPackagesHolder)